import React from 'react';
import FlexEZMegaMenu from '@components/FlexEZMegaMenu';
import { useTranslation } from 'gatsby-plugin-react-i18next';

export const useNavigationItems  = () => {
  const { t } = useTranslation("menu");

  return  [
  { id: 'home', label: t('main.home') },
  { id: 'solutions', label: t('main.solutions') },
  { 
    id: 'flexez', 
    label: 'flexEZ', 
    megamenu: FlexEZMegaMenu 
  },
  { id: 'about', label: t('main.about') },
  { id: 'contact', label: t('main.contact') }
  ]
};

// Optional: Export as default for easier imports
export default useNavigationItems ;